import { Image as ImageIcon } from 'lucide-react-native';
import { Image, StyleSheet, View } from 'react-native';

import { colors, radii } from '@/constants/theme';

/** The Figma's 52×72 video tile: Voltr's still when there is one, else a deep green tile with an image icon. */
export function UploadFileTile({ still, testID }: { still?: string; testID?: string }) {
  if (still) return <Image source={{ uri: still }} style={styles.tile} accessibilityIgnoresInvertColors testID={testID ? `${testID}-still` : undefined} />;
  return (
    <View style={[styles.tile, styles.blank]} testID={testID ? `${testID}-no-still` : undefined}>
      <ImageIcon size={22} color={colors.frost} strokeWidth={2} />
    </View>
  );
}

const styles = StyleSheet.create({
  tile: { width: 52, height: 72, borderRadius: radii.base, backgroundColor: colors.deepGreen },
  blank: { alignItems: 'center', justifyContent: 'center' },
});
